module.exports = require("plugin-assets/shared/widget/lib/util");